import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { LanguageProvider } from './contexts/LanguageContext';
import { LoadingScreen } from './components/LoadingScreen';
import './index.css';
function Root() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate loading time (minimum 2 seconds for effect)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);
  if (isLoading) {
    return <LoadingScreen data-id="element-659" />;
  }
  return <React.StrictMode data-id="element-660">
      <HelmetProvider data-id="element-661">
        <LanguageProvider data-id="element-662">
          <App data-id="element-663" />
        </LanguageProvider>
      </HelmetProvider>
    </React.StrictMode>;
}
ReactDOM.createRoot(document.getElementById('root')!).render(<Root data-id="element-664" />);